// extracted by mini-css-extract-plugin
export default {"red":"MUUEbgQdOoSMX7OmpO9U","dropdownContainer":"bm__eHnbzzL57TIsvZsW","settingsButton":"Do0xMYj15M1QoZBE4bQW"};